import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import {
    Button,
    Intent,
    Colors,
    H3
} from "@blueprintjs/core";
import NonIdeal from 'components/layout/nonIdeal/Classic'
import { base } from "../fire";
import { isEmpty } from "lodash";
import RandomString from "randomstring";
import FadeIn from 'react-fade-in'
import GeneralInfos from '../components/Creer/GeneralInfos'
import SequencePanel from "../components/Create/SequencesPanel";
import AdditionalInfos from '../components/Creer/AdditionalInfos'
import EmptyBox from '../components/Creer/EmptyBox'
import Context from '../components/Creer/Context'
import ManualChoice from '../components/Create/SetupProtocol/ManualChoice'
import "../assets/components/Create.css";
import CreatePanelProtocol from "../components/Create/ProtocolPanel";
import Auth from "../services/Auth";
import Session from "../services/Session";
import { storage } from "../fire";
import Loader from 'components/layout/loaders/Classic'
class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessionNotFound: true,
            loadingData: true,
            loadingMetadata: true,
            loadingInstances: true,
            loadingDelete: false,
            data: {},
            metadata: {},
            instances: [],
            language: "fr",
            shouldPromptUserName: false
        };
        this.baseEndpoint = "";
        this.sessionId = this.props.match.params.id;
    }

    createSequenceCM = () => {
        let sequences = this.state.data.sequences
        if (sequences && sequences.length > 0) {
            this.setState({
                data: {
                    ...this.state.data, sequences: [...this.state.data.sequences, {
                        intro: '',
                        resources: [],
                        attributes: '',
                        sequencesContext: '',
                        attribute: []
                    }]
                }
            })
        } else {
            this.setState({
                data: {
                    ...this.state.data, sequences: [{
                        intro: '',
                        resources: [],
                        attributes: '',
                        sequencesContext: '',
                        attribute: []
                    }]
                }
            })
        }
    }


    handleChangeContextCM = (index, value) => {
        let sequences = this.state.data.sequences

        sequences[index - 1].sequenceContext = value
        this.setState({ data: { ...this.state.data, sequences: sequences } })
    }

    handleChangeSequencesResourcesCM = (index, sequencesResources) => {

        let sequences = this.state.data.sequences
        let sequence = this.state.data.sequences[index - 1]
        let newResources = sequencesResources

        if (sequence.resources && sequence.resources.length) {
            sequence.resources.forEach((resource) => {
                newResources = newResources.filter(item => !(item.id === resource.id));
            })
        }

        if (sequence.resources) {
            sequence.resources = [...sequence.resources, ...newResources]
        } else {
            sequence.resources = [...newResources]
        }

        sequences[index - 1] = sequence

        this.setState({ data: { ...this.state.data, sequences: sequences } })
    }

    handleReplacesResources = (sequenceIndex, resources) => {
        let sequences = this.state.data.sequences
        sequences[sequenceIndex - 1].resources = resources

        this.setState({ data: { ...this.state.data, sequences } })
    }

    handleChangeAttributeCM = (name, unit, ref, attr, sequenceIndex) => {

        let sequences = this.state.data.sequences
        let attributes = this.state.data.sequences[sequenceIndex - 1].attributes

        if (!attributes) {
            attributes = []
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else if (!attributes[attr]) {
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else {
            attributes[attr].name = name
            attributes[attr].unit = unit
            attributes[attr].id = RandomString.generate(16)
            attributes[attr].ref = ref
        }

        sequences[sequenceIndex - 1].attributes = attributes

        this.setState({ data: { ...this.state.data, sequences } })
    }

    handleChangeAttributeUnitValueCM = (value, attr, ress, sequenceIndex) => {
        let sequences = this.state.data.sequences
        let files = this.state.data.sequences[sequenceIndex - 1].resources

        if (!files[ress].attributes) {
            files[ress].attributes = []
            files[ress].attributes.push({ quantity: value })
        } else if (!files[ress].attributes[attr]) {
            files[ress].attributes.push({ quantity: value })
        } else {
            files[ress].attributes[attr] = { quantity: value }
        }

        sequences[sequenceIndex - 1].resources = files

        this.setState({ data: { ...this.state.data, sequences } })

    }

    handleDeleteAttributeCM = (attr, index, sequenceIndex) => {
        this.setState({ loadingDelete: true }, () => {

            let sequences = this.state.data.sequences
            let sequence = this.state.data.sequences[sequenceIndex - 1]

            sequence.attributes = sequence.attributes.filter(attribute => attribute !== attr)

            sequence.resources.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            sequences[sequenceIndex - 1] = sequence

            this.setState({
                data: { ...this.state.data, sequences }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }

    handleChangeIntroCM = (intro, sequenceIndex) => {
        let sequences = this.state.data.sequences
        let sequence = this.state.data.sequences[sequenceIndex - 1]

        sequence.intro = intro

        sequences[sequenceIndex - 1] = sequence

        this.setState({ data: { ...this.state.data, sequences } });
    }

    handleDeleteAttributeMC = (attr, index) => {
        this.setState({ loadingDelete: true }, () => {
            let attributes = this.state.metadata.attributes
            let mcCriterias = this.state.data.mcCriterias

            attributes = attributes.filter(attribute => attribute !== attr)

            mcCriterias.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            this.setState({
                metadata: { ...this.state.metadata, attributes: attributes },
                data: { ...this.state.data, mcCriterias: mcCriterias }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }

    displayContextCM = () => {
        this.setState({ CMContext: true })
    }

    handleInputChange = (name, value) => {
        const { metadata } = this.state;

        this.setState({ metadata: { ...metadata, [name]: value } });
    };

    handleChangeCriteria_MS = msCriterias =>
        this.setState({ data: { ...this.state.data, msCriterias } });

    handleChangeCriteria_MC = mcCriterias =>
        this.setState({ data: { ...this.state.data, mcCriterias } });

    handleChangeCriteriaName = (id, name) => {
        let crits = this.state.data.mcCriterias
        crits[id].name = name
        this.setState({ data: { ...this.state.data, mcCriterias: crits } })
    }

    handleChangeFeedbacks = feedbacks =>
        this.setState({ data: { ...this.state.data, feedbacks } });

    handleChangeInterludes = interludes =>
        this.setState({ data: { ...this.state.data, interludes } });

    handleChangeConclusion = conclusions =>
        this.setState({ data: { ...this.state.data, conclusions } })


    handleChangeSequences = sequences =>
        this.setState({ data: { ...this.state.data, sequences } });

    handleChangeSequencesResources = sequencesResources =>
        this.setState({ data: { ...this.state.data, sequencesResources } });

    handleDeleteAttribute = (attr, index) => {
        this.setState({ loadingDelete: true }, () => {
            let attributes = this.state.metadata.attributes
            let sequencesResources = this.state.data.sequencesResources

            attributes = attributes.filter(attribute => attribute !== attr)

            sequencesResources.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            this.setState({
                metadata: { ...this.state.metadata, attributes: attributes },
                data: { ...this.state.data, sequencesResources: sequencesResources }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }

    handleDeleteAttributeMC = (attr, index) => {
        this.setState({ loadingDelete: true }, () => {
            let attributes = this.state.metadata.attributes
            let mcCriterias = this.state.data.mcCriterias

            attributes = attributes.filter(attribute => attribute !== attr)

            mcCriterias.forEach((resource) => {
                if (resource.attributes) {
                    resource.attributes.splice(index, 1)
                }
            })

            this.setState({
                metadata: { ...this.state.metadata, attributes: attributes },
                data: { ...this.state.data, mcCriterias: mcCriterias }
            }, () => {
                this.setState({ loadingDelete: false })
            })
        })
    }

    handleChangeAttribute = (name, unit, ref, attr) => {
        let attributes = []
        attributes = this.state.metadata.attributes
        if (!attributes) {
            attributes = []
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else if (!attributes[attr]) {
            attributes.push({ name: name, unit: unit, id: RandomString.generate(16), ref: ref })
        } else {
            attributes[attr].name = name
            attributes[attr].unit = unit
            attributes[attr].id = RandomString.generate(16)
            attributes[attr].ref = ref
        }

        this.setState({ metadata: { attributes: attributes } })
    }

    handleChangeAttributeUnitValue = (value, attr, ress, isMC) => {
        let files = this.state.data.sequencesResources
        let withFixedChannel = this.state.data.mcCriterias && this.state.data.mcCriterias.find(crit => crit.isFixed) 
        if (isMC) {
            files = this.state.data.mcCriterias
        }
        if (!files[ress].attributes) {
            files[ress].attributes = []
            files[ress].attributes.push({ quantity: value })
        } else if (!files[ress].attributes[attr]) {
            files[ress].attributes.push({ quantity: value })
        } else {
            files[withFixedChannel ? parseInt(ress) + 1 : ress].attributes[attr] = { quantity: value }
        }

        if (!isMC) {
            this.setState({ data: { sequencesResources: files } })
        } else {
            this.setState({ data: { mcCriterias: files } })
        }
    }

    validateProtocol = () => {
        const { protocol } = this.state.metadata;

        return protocol != null && protocol.length > 0;
    };

    validateType = () => {
        const { type } = this.state.metadata;

        return type != null && type.length > 0;
    };

    validateName = () => {
        const { name } = this.state.metadata;

        return name != null && name.length > 0;
    };

    handleAddPersonalQuestion = (personalQuestion) => {
        if (!this.state.metadata.personalQuestions) {
            this.setState({ metadata: { ...this.state.metadata, personalQuestions: [personalQuestion] } })
        } else {
            let questions = this.state.metadata.personalQuestions
            this.setState({ metadata: { ...this.state.metadata, personalQuestions: [...questions, personalQuestion] } })
        }
    }

    handleRemovePersonalQuestion = (id) => {
        let questions = this.state.metadata.personalQuestions
        questions = questions.filter(question => question.id !== id)
        this.setState({ metadata: { ...this.state.metadata, personalQuestions: questions } })
    }

    emptyFeedbacks = () => {
        const { data } = this.state;
        this.setState({ data: { ...data, feedbacks: [] } })
    }

    emptyPersonalQuestions = () => {
        const { metadata } = this.state;

        this.setState({ metadata: { ...metadata, personalQuestions: [] } })
    }


    deleteAllInterludes = () => {
        if (this.state.data.interludes && this.state.data.interludes.length > 0) {
            this.state.data.interludes.forEach((interlude, i) => {
                let id = interlude.fileInternalName
                const storageRef = storage.ref(
                    `interludes/${Auth.getUserId()}/${this.state.sessionId}/${this.state.data.interludes.find(i => i.fileInternalName === id).fileInternalName
                    }`
                );
                storageRef.delete()
            })
            this.setState({ data: { ...this.state.data, interludes: [] } })
        }
    }

    deleteAllConclusions = () => {
        if (this.state.data.conclusions && this.state.data.conclusions.length > 0) {
            this.state.data.conclusions.forEach((conclusion, i) => {
                let id = conclusion.fileInternalName
                const storageRef = storage.ref(
                    `conclusions/${Auth.getUserId()}/${this.state.sessionId}/${this.state.data.conclusions.find(i => i.fileInternalName === id).fileInternalName
                    }`
                );
                storageRef.delete()
            })
            this.setState({ data: { ...this.state.data, conclusions: [] } })
        }
    }

    deleteChainedSession = () => {
        this.setState({ metadata: { ...this.state.metadata, chainedSession: '' } })
    }

    render() {

        if (
            this.state.loadingData ||
            this.state.loadingMetadata ||
            this.state.loadingInstances
        )
            return (
                <Loader />
            );

        if (this.state.sessionNotFound)
            return (
                <NonIdeal
                    icon="thumbs-down"
                    title="Session not found"
                    desc="We couldn't find the session you are looking to edit."
                    url="/"
                />
            );

        const { metadata, data } = this.state;
        const {
            msCriterias = [],
            mcCriterias = [],
            feedbacks = [],
            sequences = [],
            sequencesResources = [],
            interludes = [],
            conclusions = []
        } = data;

        const chainedSession = this.state.metadata && this.state.metadata.chainedSession;

        const hasBeenPlayed = this.state.instances.length > 0;
        
        return (
            <div className="main animated fadeIn">
                <div className="text-right" style={{ marginBottom: "10px" }}>
                    <Button
                        text="Your session is automatically saved"
                        rightIcon="tick"
                        style={{ color: Colors.GREEN3, marginRight: "5px" }}
                        intent={Intent.NONE}
                        disabled={true}
                    />
                    <Link to="/">
                        <Button
                            text="Finish"
                            rightIcon="confirm"
                            intent={Intent.SUCCESS}
                        />
                    </Link>
                </div>
                {/* GENERAL INFOS */}
                <H3 className='text-center margin-bottom-medium'>Configure your session</H3>
                <FadeIn>
                    <GeneralInfos
                        {...metadata}
                        onInputChange={this.handleInputChange}
                        msCriterias={this.state.data.msCriterias}
                        resources={sequencesResources}
                        mcCriterias={this.state.data.mcCriterias}
                    />
                </FadeIn>

                {/* IMAGES */}
                {metadata.protocol &&
                    <FadeIn>
                        <H3 className='text-center margin-bottom-medium'>
                            {(metadata.protocol === 'PC') && 'Your Images*'}
                            {(metadata.protocol === 'MS') && 'Your Images*'}
                            {(metadata.protocol === 'MC') && 'Your Channels*'}
                        </H3>
                        {(metadata.protocol === 'CM') &&
                            <ManualChoice
                                createSequence={this.createSequenceCM}
                                changeContext={this.handleChangeContextCM}
                                sequences={sequences}
                                changeResources={this.handleChangeSequencesResourcesCM}
                                handleChangeSequencesResourcesCM={this.handleChangeSequencesResourcesCM}
                                attributes={this.state.metadata.attributes}
                                handleChangeAttribute={this.handleChangeAttributeCM}
                                handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValueCM}
                                handleDeleteAttribute={this.handleDeleteAttributeCM}
                                loadingDelete={this.state.loadingDelete}
                                handleReplacesResources={this.handleReplacesResources}
                                sessionId={this.state.id}
                                onChangeInterludes={this.handleChangeIntroCM}
                                displayContextCM={this.displayContextCM}
                                editMode={true}
                            />
                        }
                        {(metadata.protocol === 'MC') &&
                            <FadeIn>
                                {this.state.loadingDelete
                                    ?
                                    <Loader />
                                    :
                                    <CreatePanelProtocol
                                        sessionId={this.state.id}
                                        protocol={this.state.metadata.protocol}
                                        mcCriterias={mcCriterias}
                                        msCriterias={msCriterias}
                                        onChangeCriteria_MC={this.handleChangeCriteria_MC}
                                        onChangeCriteria_MS={this.handleChangeCriteria_MS}
                                        onChangeCriteriaName={this.handleChangeCriteriaName}
                                        attributes={this.state.metadata.attributes}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttributeMC}
                                    />}
                            </FadeIn>
                        }
                        {(metadata.protocol === 'PC' || metadata.protocol === 'MS') &&
                            <FadeIn>
                                {this.state.loadingDelete
                                    ?
                                    <Loader />
                                    :
                                    <SequencePanel
                                        sessionId={this.state.id}
                                        protocol={metadata.protocol}
                                        mcCriterias={mcCriterias} // Only for MC to set channels uses by sequences
                                        sequences={sequences}
                                        attributes={metadata.attributes}
                                        resources={sequencesResources}
                                        onChangeSequences={this.handleChangeSequences}
                                        onChangeSequencesResources={this.handleChangeSequencesResources}
                                        onchangeMeta={this.handleChangeInput}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttribute}
                                    />}
                            </FadeIn>
                        }
                        {/* CONFIGURE PROTOCOL */}
                        {(data.sequencesResources
                            && data.sequencesResources.length > 0
                            && metadata.protocol === 'MS'
                            && data.sequences) &&
                            <FadeIn>
                                {this.state.loadingDelete
                                    ?
                                    <Loader />
                                    :
                                    <CreatePanelProtocol
                                        sessionId={this.state.id}
                                        protocol={this.state.metadata.protocol}
                                        mcCriterias={mcCriterias}
                                        msCriterias={msCriterias}
                                        onChangeCriteria_MC={this.handleChangeCriteria_MC}
                                        onChangeCriteria_MS={this.handleChangeCriteria_MS}
                                        onChangeCriteriaName={this.handleChangeCriteriaName}
                                        attributes={this.state.metadata.attributes}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttributeMC}
                                    />
                                }
                            </FadeIn>
                        }
                        {(metadata.protocol === 'MC'
                            && mcCriterias
                            && mcCriterias.length > 0) &&
                            <FadeIn className='margin-top-large'>
                                {this.state.loadingDelete
                                    ?
                                    <Loader />
                                    :
                                    <SequencePanel
                                        sessionId={this.state.id}
                                        protocol={metadata.protocol}
                                        mcCriterias={mcCriterias} // Only for MC to set channels uses by sequences
                                        sequences={sequences}
                                        attributes={metadata.attributes}
                                        resources={sequencesResources}
                                        onChangeSequences={this.handleChangeSequences}
                                        onChangeSequencesResources={this.handleChangeSequencesResources}
                                        onchangeMeta={this.handleChangeInput}
                                        handleChangeAttribute={this.handleChangeAttribute}
                                        handleChangeAttributeUnitValue={this.handleChangeAttributeUnitValue}
                                        handleDeleteAttribute={this.handleDeleteAttribute}
                                    />
                                }
                            </FadeIn>

                        }
                        {/* ADDITIONAL INFORMATIONS */}

                        {(sequences && sequences.length > 0) &&
                            <Fragment>
                                <FadeIn>
                                    <H3 className='text-center margin-bottom-medium margin-top-medium'>Context of the session*</H3>
                                    <Context
                                        context={this.state.metadata.context}
                                        onInputChange={this.handleInputChange}
                                    />
                                </FadeIn>

                                
                                {((metadata.protocol === 'PC' || metadata.context) && (metadata.protocol !== 'MS')) &&
                                    <AdditionalInfos
                                        protocol={metadata.protocol}
                                        feedbacks={feedbacks}
                                        handleChangeFeedbacks={this.handleChangeFeedbacks}
                                        handleChangeInput={this.handleInputChange}
                                        interludes={interludes}
                                        sessionId={this.sessionId}
                                        handleChangeInterludes={this.handleChangeInterludes}
                                        conclusions={conclusions}
                                        chainedSession={chainedSession}
                                        handleChangeConclusion={this.handleChangeConclusion}
                                        personalQuestions={this.state.metadata.personalQuestions}
                                        addPersonalQuestion={this.handleAddPersonalQuestion}
                                        handleRemovePersonalQuestion={this.handleRemovePersonalQuestion}
                                        emptyPersonalQuestions={this.emptyPersonalQuestions}
                                        emptyFeedbacks={this.emptyFeedbacks}
                                        type={this.state.metadata.type}
                                        deleteAllInterludes={this.deleteAllInterludes}
                                        deleteAllConclusions={this.deleteAllConclusions}
                                        deleteChainedSession={this.deleteChainedSession}
                                        editMode={true}
                                        hasBeenPlayed={hasBeenPlayed}
                                    />
                                }
                                {((metadata.protocol === 'MS') && data.msCriterias) &&
                                    <AdditionalInfos
                                        protocol={metadata.protocol}
                                        feedbacks={feedbacks}
                                        handleChangeFeedbacks={this.handleChangeFeedbacks}
                                        handleChangeInput={this.handleInputChange}
                                        interludes={interludes}
                                        sessionId={this.sessionId}
                                        handleChangeInterludes={this.handleChangeInterludes}
                                        conclusions={conclusions}
                                        chainedSession={chainedSession}
                                        handleChangeConclusion={this.handleChangeConclusion}
                                        personalQuestions={this.state.metadata.personalQuestions}
                                        addPersonalQuestion={this.handleAddPersonalQuestion}
                                        handleRemovePersonalQuestion={this.handleRemovePersonalQuestion}
                                        emptyPersonalQuestions={this.emptyPersonalQuestions}
                                        emptyFeedbacks={this.emptyFeedbacks}
                                        type={this.state.metadata.type}
                                        deleteAllInterludes={this.deleteAllInterludes}
                                        deleteAllConclusions={this.deleteAllConclusions}
                                        deleteChainedSession={this.deleteChainedSession}
                                        editMode={true}
                                        hasBeenPlayed={hasBeenPlayed}
                                    />
                                }
                            </Fragment>
                        }

                    </FadeIn>
                }
                <EmptyBox size='smallContainer' />
                <div className="text-right" style={{ marginTop: "30px" }}>
                    <Button
                        text="Your session is automatically saved"
                        rightIcon="tick"
                        style={{ color: Colors.GREEN3, marginRight: "5px" }}
                        intent={Intent.NONE}
                        disabled={true}
                    />
                    <Link to="/">
                        <Button
                            text="Finish"
                            rightIcon="confirm"
                            intent={Intent.SUCCESS}
                        />
                    </Link>
                </div>
                <br /><br />
            </div>
        );
    }

    componentWillMount() {
        this.baseEndpoint = `sessions/${Auth.getUserId()}`;
        const endpoint = `${this.baseEndpoint}/${this.sessionId}`;

        Session.getSessionById(this.sessionId).then(session => {
            // An empty object is returned ? We do not have session for the given id
            if (isEmpty(session))
                return this.setState({ loadingMetadata: false, loadingData: false });
            // We have a session for the given id, we setup the sync with Firebase
            this.syncMetadataRef = base.syncState(`${endpoint}/metadata`, {
                context: this,
                state: "metadata",
                then: () => this.setState({ loadingMetadata: false })
            });
            this.syncDataRef = base.syncState(`${endpoint}/data`, {
                context: this,
                state: "data",
                then: () => this.setState({ loadingData: false })
            });
            Session.getSessionInstances(this.sessionId).then(instances =>
                this.setState({ instances, loadingInstances: false })
            );
            this.setState({ sessionNotFound: false });
        });
    }

    componentWillUnmount() {
        if (this.syncDataRef) base.removeBinding(this.syncDataRef);
        if (this.syncMetadataRef) base.removeBinding(this.syncMetadataRef);
    }
}

export default Edit;
